import React, { useEffect, useState } from 'react'
import styled, { useTheme } from 'styled-components';
import StyledButton from '../../app/components/styledComponents/StyledButton';
import { StyledLabel } from '../../assets/styledComponents/Global';
import CountDownProgress from './CountDownProgress';
import ThinkTimer from './ThinkTimer';
import { useWindowSize } from '../../utils/helper';
import { getAll } from '../../app/services/indexedDBService';
import CircularProgress from './CircularProgress';
import ClockIcon from '../../app/components/svgIcons/ClockIcon';
import moment from 'moment';

const VideoRecorder = ({ videoProfileRes, startRecord, skipPreparation, previewRef, waveformRef, isRecording, endInterview, timer, stopRecording, thinkCountdown, countdown, phase, totalCountdown, questionsList }) => {
  const theme = useTheme();
  const isSmallScreen = useWindowSize()
  const formatTime = (s) => {
    const m = String(Math.floor(s / 60)).padStart(2, '0');
    const sec = String(s % 60).padStart(2, '0');
    return `${m}:${sec}`;
  };
  const RecordingIndicator = () => {
    const pulseRing = {
      animation: "pulse-ring 3.5s infinite",
    };

    const pulseCore = {
      animation: "pulse-core 4.5s infinite alternate",
    };

    return (
      <>
        <style>
          {`
              @keyframes pulse-ring {
                0% { transform: scale(1); opacity: 1; }
                70% { transform: scale(1.8); opacity: 0; }
                // 100% { opacity: 0; }
                70% { transform: scale(1.8); opacity: 0; }
                 0% { transform: scale(1); opacity: 1; }
              }
    
              @keyframes pulse-core {
                0% { transform: scale(1); }
                100% { transform: scale(1.3); }
                0% { transform: scale(1); }
    
              }
            `}
        </style>

        <div
          className="d-flex bg-white align-items-center justify-content-center rounded-circle"
          style={{ height: "30px", width: "30px" }}
        >
          <div
            className="d-flex bg-transparent align-items-center justify-content-center border border-1 border-secondary rounded-circle"
            style={{ height: "15px", width: "15px", ...pulseRing }}
          >
            <div
              className="bg-danger rounded-circle"
              style={{ height: "9px", width: "9px", ...pulseCore }}
            ></div>
          </div>
        </div>
      </>
    );
  };

  const [progressMap, setProgressMap] = useState({});

  useEffect(() => {
    let interval = setInterval(async () => {
      try {
        const all = await getAll("uploads");

        // 👇 sirf current appId ke records filter karo
        const currentAppId = videoProfileRes?.videoApplication?.id;
        const filtered = all.filter(item => item.appId === currentAppId);

        const obj = {};
        filtered.forEach((item) => {
          obj[item.id] = item;
        });

        setProgressMap(obj);
      } catch (err) {
        console.error('Failed to read upload progress from IndexedDB:', err);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [videoProfileRes]);

  const [open, setOpen] = useState(false);
  return (
    <>
      <div style={{ position: 'relative', minWidth: isSmallScreen ? '100%' : '768px' }}>

        <StyledGraphWrap isRecording={isRecording} isSmallScreen={isSmallScreen} className={'p-2'}>
          <ResponsiveVideo ref={previewRef} autoPlay muted playsInline
            style={{
              display: 'flex', justifyContent: 'center', alignItems: 'center',
              transform: 'scaleX(-1)', width: '100%', height: 'auto', minWidth: isSmallScreen ? '100%' : '760px', maxWidth: isSmallScreen ? '100%' : '760px', minHeight: '390px', maxHeight: '390px',
              borderRadius: '6px',
              // aspectRatio: '16 / 9',
            }}
          />
          {startRecord && (
            <canvas ref={waveformRef} width={800} height={60}
              style={{ position: 'absolute', bottom: '25px', zIndex: '99', width: '36px', left: '5%', height: '36px', marginTop: '12px', borderRadius: '999px', backgroundColor: '#000' }}
            />
          )}
        </StyledGraphWrap>


        {isRecording && !endInterview && (
          <StyledLayer>
            <StyledLabel size="14px" fontWeight="500" color={theme?.subText} className='bg-white px-3 py-2 rounded-pill' >
              {formatTime(timer)}
            </StyledLabel>
            <RecordingIndicator />
          </StyledLayer>
        )}

        {(countdown > 0 || thinkCountdown > 0) && videoProfileRes?.videoApplication?.allowedTime && (
        <StyledLayer2 className='text-primary'>
          <StyledLabel size="14px" fontWeight="500" color={theme?.subText} className={`bg-white cursor-pointer px-1 py-1 ${open ? 'rounded-pill' : 'rounded-circle'}`}
            onClick={() => setOpen(!open)}
          >

            {open ? `${!isSmallScreen ? ' Video profile expires' : "Expires"} in ${moment(videoProfileRes?.videoApplication?.expireAt).fromNow(true)} (${moment(videoProfileRes?.videoApplication?.expireAt).format("D MMM, YYYY - h:mm A")})` : ''}
            <ClockIcon size={20} className={open && 'ms-2'} color={theme?.darktext} />
          </StyledLabel>

        </StyledLayer2 >
         )} 


        {
          countdown > 0 && phase === "recording" && (

            <CountDownProgress countdown={countdown} totalCountdown={totalCountdown} />
          )
        }
        {
          thinkCountdown > 0 && phase === "thinking" && (

            <ThinkTimer skipPreparation={skipPreparation} thinkCountdown={thinkCountdown} />


          )
        }
      </div >

      {isRecording && !endInterview && (
        <div className={`d-flex ${isSmallScreen ? 'justify-content-between align-items-center' : 'justify-content-end'}`}>
          {isSmallScreen && <CircularProgress count={Object.values(progressMap).filter(item => item.progress === 100 || item.status === "uploaded").length} total={questionsList?.length} />
          }
          <StyledButton className='bg-secondary text-white border-0' onClick={stopRecording} style={{ marginTop: 10 }}  >
            Finish Answer{' '}
          </StyledButton>
        </div>
      )}
    </>
  )
}

export default VideoRecorder


const ResponsiveVideo = styled.video`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 16px;
  background-color: #000;
`;


const StyledLayer = styled.div`
  position: absolute;
  {/* background: #9cbdf699; */}
  width:${({ isSmallScreen }) => isSmallScreen ? '80%' : '100%'};  
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 2px;
  top: 20px;
  z-index: 9;
  padding:20px;


`;


const StyledLayer2 = styled.div`
  position: absolute;
  width:${({ isSmallScreen }) => isSmallScreen ? '80%' : '100%'};  
  display:flex;
  justify-content:center;
  align-items:center;
  top: 33px;
  right:2px;
  border-radius:9999px;
  height:38px;
  width:max-content;
  // z-index: 9;
  padding:20px;
`;

// const StyledGraphWrap = styled.div`
//   --angle: 0deg;
//   --opacity: 0.5;
//   min-width:770px;
//   min-height:390px;
//   position: relative;
//   padding: 0px;
//   margin: 0px;
//   border-radius: 14px;
//   border: var(--border-size) solid transparent;

//   @property --angle {
//     syntax: "<angle>";
//     initial-value: 0deg;
//     inherits: true;
//   }

//   &::before {
//     content: "";
//     position: absolute;
//     inset: 0;
//     border-radius: inherit;
//     padding: 8px;
//     background: conic-gradient(
//       from var(--angle),
//       #007470,
//       #007470 0%,
//       transparent 25%,
//       transparent 100%
//     );
//     -webkit-mask:
//       linear-gradient(#fff 0 0) content-box,
//       linear-gradient(#fff 0 0);
//     -webkit-mask-composite: xor;
//     mask-composite: exclude;
//     animation: rotate 10s linear infinite;
//     pointer-events: none;
//   }

//   @keyframes rotate {
//     from {
//       --angle: 0deg;
//     }
//     to {
//       --angle: 360deg;
//     }
//   }
// `;


const StyledGraphWrap = styled.div`
  --angle: 0deg;
  min-width:${({ isSmallScreen }) => isSmallScreen ? '100%' : '770px'};
  min-height: 390px;
  position: relative;
  border-radius: 14px;

  @property --angle {
    syntax: "<angle>";
    initial-value: 0deg;
    inherits: true;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 8px;
    diaplay: flex;
    align-items: center;
    justify-content: center;

    background: ${({ isRecording }) =>
    isRecording
      ? "transparent"
      : `conic-gradient(
            from var(--angle),
            #007470,
            #007470 0%,
            transparent 25%,
            transparent 100%
          )`};

    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;

    animation: ${({ isRecording }) =>
    isRecording ? "none" : "rotate 10s linear infinite"};
  }

  @keyframes rotate {
    from {
      --angle: 0deg;
    }
    to {
      --angle: 360deg;
    }
  }
`;
